/**
 * ApplyGlobalConfirmDialog - Confirmation Dialog für Global Settings Anwendung
 *
 * Fragt User, ob globale Settings auf bestehende Zeilen angewendet werden sollen.
 */

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/v2/ui/Dialog';
import { Button } from '@/components/v2/ui/Button';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export interface ApplyGlobalConfirmDialogProps {
  open: boolean;
  onConfirm: () => void; // Alle überschreiben
  onCancel: () => void; // Nur neue Zeilen
  affectedRowsCount: number;
}

export function ApplyGlobalConfirmDialog({
  open,
  onConfirm,
  onCancel,
  affectedRowsCount,
}: ApplyGlobalConfirmDialogProps) {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-yellow-500" />
            Globale Einstellungen anwenden?
          </DialogTitle>
        </DialogHeader>

        <div className="py-4 text-sm text-neutral-600 dark:text-neutral-400">
          Sie haben <span className="font-semibold text-neutral-900 dark:text-neutral-100">{affectedRowsCount} Zeilen</span> bereits konfiguriert.
          {t('batch.applyGlobalSettings')}
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="ghost" onClick={onCancel}>
            {t('common.cancel')}
          </Button>
          <Button variant="secondary" onClick={onCancel}>
            Nur neue Zeilen
          </Button>
          <Button variant="warning" onClick={onConfirm}>
            {t('batch.overwriteAll')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
